import { styled } from '@mui/system';
import { Box } from 'shared/mui/Box';

export const BoxStyled = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '16px',
});
